export default "__VITE_ASSET__8d22ceca__"